import { render, staticRenderFns } from "./FitnessPlanner.vue?vue&type=template&id=63786cb4&scoped=true"
import script from "./FitnessPlanner.vue?vue&type=script&lang=js"
export * from "./FitnessPlanner.vue?vue&type=script&lang=js"
import style0 from "./FitnessPlanner.vue?vue&type=style&index=0&id=63786cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63786cb4",
  null
  
)

export default component.exports